import { warehouseListI } from 'interfaces';
import { create } from 'zustand';

interface WharehouseProps {
  wharehouse: warehouseListI | null;
  setWarehouse: (option: warehouseListI | null) => void;
  isEdit: boolean;
  setIsEdit: (state: boolean) => void;
  idWarehouseEdit: number;
  setIdWarehouseEdit: (id: number) => void;

  isOpenModalWarehouse: boolean;
  handleOpenModalWarehouse: () => void;
  handleCloseModalWarehouse: () => void;
}

export const useWarehouseStore = create<WharehouseProps>((set, get) => ({
  wharehouse: null,
  isEdit: false,
  idWarehouseEdit: 0,
  setWarehouse: (warehpuseParam: warehouseListI | null) => {
    set({ wharehouse: warehpuseParam });
  },
  setIsEdit: (state: boolean) => {
    set({ isEdit: state });
  },
  setIdWarehouseEdit: (id: number) => {
    set({ idWarehouseEdit: id });
  },
  isOpenModalWarehouse: false,
  handleOpenModalWarehouse: () => {
    set((state) => ({
      ...state,
      isOpenModalWarehouse: !state.isOpenModalWarehouse,
    }));
  },
  handleCloseModalWarehouse: () => {
    set((state) => ({ ...state, isOpenModalWarehouse: false }));
  },
}));
